<div class="alert-container">
  @for (alert of alerts; track alert.id; let i = $index) {
    <div
      [@fadeShrinkInOut]="'inOut'"
      class="alert-item"
      [class]="alert.className"
      role="alert"
    >
      <div class="alert-content">
        <div class="alert-type">
          <span [class]="'badge ' + getAlertBadgeClass(i)">{{
            alert.typeName
          }}</span>
        </div>
        <div class="alert-timestamp">
          {{ alert.timestamp | date: 'medium' }}
        </div>
        <div class="alert-message">
          [{{ alert.code }}]
          {{ alert.message | titlecase }}
        </div>
        <div class="alert-actions">
          <button
            type="button"
            class="alert-dismiss-btn"
            (click)="onAlertDismiss(alert.id)"
          >
            Dismiss{{ getAlertCountdown(i) }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
